import React from "react";
import { cn } from "@/lib/utils";

const TICKET_STATUS_STYLES = {
  Received: { cls: "bg-slate-50 text-slate-700 ring-slate-200", dot: "bg-slate-400" },
  Pending: { cls: "bg-amber-50 text-amber-800 ring-amber-200", dot: "bg-amber-500" },
  "Awaiting Approval": { cls: "bg-orange-50 text-orange-800 ring-orange-200", dot: "bg-orange-500" },
  Approved: { cls: "bg-blue-50 text-blue-800 ring-blue-200", dot: "bg-blue-500" },
  Rejected: { cls: "bg-rose-50 text-rose-800 ring-rose-200", dot: "bg-rose-500" },
  "Return Label Sent": { cls: "bg-violet-50 text-violet-800 ring-violet-200", dot: "bg-violet-500" },
  "Return Shipped": { cls: "bg-indigo-50 text-indigo-800 ring-indigo-200", dot: "bg-indigo-500" },
  Completed: { cls: "bg-emerald-50 text-emerald-800 ring-emerald-200", dot: "bg-emerald-500" },
};

export const TICKET_STATUS_COLORS = {
  Received: "#94a3b8",
  Pending: "#f59e0b",
  "Awaiting Approval": "#f97316",
  Approved: "#2563eb",
  Rejected: "#dc2626",
  "Return Label Sent": "#7c3aed",
  "Return Shipped": "#6366f1",
  Completed: "#16a34a",
};

export function TicketStatusBadge({ status }) {
  const s = TICKET_STATUS_STYLES[status] || TICKET_STATUS_STYLES.Received;
  return (
    <span className={cn("inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset", s.cls)}>
      <span className={cn("h-1.5 w-1.5 rounded-full", s.dot)} />
      {status}
    </span>
  );
}
